import React from 'react'

const MapViewPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Map View Page</h1>
      <p>This is a placeholder for the Map View page.</p>
    </div>
  )
}

export default MapViewPage